export default __webpack_public_path__ + "static/media/logo1.a9370e55.svg";